import { useContext } from "react"
import { UserContext } from "../../store/store"

export const Loading = ({ text = null }) => {
  const [state] = useContext(UserContext)

  // imgs
  const loading_light = require("../../assets/img/loading-light.gif").default,
    loading_dark = require("../../assets/img/loading-dark.gif").default

  return (
    <>
      <div className="d-flex align-items-center">
        <img
          alt="loading"
          src={state.theme === "light" ? loading_dark : loading_light}
          width="24"
        />
        {text}
      </div>
    </>
  )
}
